import {
  Avatar as ChakraAvatar,
  AvatarBadge,
  AvatarBadgeProps,
  AvatarProps as ChakraAvatarProps,
  useMultiStyleConfig,
} from '@chakra-ui/react';

export interface AvatarProps extends ChakraAvatarProps {
  hasBadge?: boolean;
  badgeProps?: AvatarBadgeProps;
}

export const Avatar = (props: AvatarProps) => {
  const { hasBadge, badgeProps, ...rest } = props;
  const styles = useMultiStyleConfig('Avatar', props);

  return (
    <ChakraAvatar sx={{ ...styles.Avatar }} size='sm' {...rest}>
      {hasBadge && (
        <AvatarBadge sx={{ ...styles.AvatarBadge }} {...badgeProps} />
      )}
    </ChakraAvatar>
  );
};
